import {ApolloClient, from, InMemoryCache, TypePolicies} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {createUploadLink} from 'apollo-upload-client';

let client: ApolloClient<any>;

const httpLink = createUploadLink({
    uri: process.env.NEXT_PUBLIC_GRAPHQL_URI,
});

const getAuthLink = (sessionRef: React.RefObject<any> | undefined) => {
    return setContext((_, {headers}) => {
        return {
            headers: {
                ...headers,
                authorization: sessionRef?.current?.accessToken ? 'Bearer ' + sessionRef.current.accessToken : undefined,
            },
        };
    });
};

function createApolloClient(sessionRef: React.RefObject<any> | undefined) {
    return new ApolloClient({
        ssrMode: typeof window === undefined,
        //@ts-ignore
        link: from([getAuthLink(sessionRef), httpLink]),
        cache: new InMemoryCache({
            typePolicies: getTypePolicies(),
        }),
    });
}

export function initializeApollo(initialCache: any | undefined = undefined, sessionRef: React.RefObject<any> | undefined = undefined) {
    const _apolloClient = client ?? createApolloClient(sessionRef);
    if (initialCache) {
        _apolloClient.restore(initialCache);
    }
    if (typeof window === 'undefined') return _apolloClient;
    if (client) client = _apolloClient;
    return _apolloClient;
}

function getTypePolicies(): TypePolicies {
    return {
        Query: {
            fields: {
                advert: {
                    read(_, {args, toReference}) {
                        return toReference({
                            __typename: 'Advert',
                            id: args?.id,
                        });
                    },
                },
                region: {
                    read(_, {args, toReference}) {
                        return toReference({
                            __typename: 'Region',
                            id: args?.id,
                        });
                    },
                },
            },
        },
    };
}
